export const TOGGLE_VISIBILITY = 'TOGGLE_CONTROL_PANEL_VISIBILITY';
export const CLOSE = 'CLOSE_CONTROL_PANEL';

export const toggleControlPanelVisibility = () => ({
    type: TOGGLE_VISIBILITY,
});

export const closeControlPanel = () => ({
    type: CLOSE,
});



// WEBPACK FOOTER //
// ./src/actions/notes_control_panel.js